/* ==========================================================================
   ASK FORM – SHARED FILE (identical on all 5 stores)
   Drives snippets/ask-form.liquid: the whole form is visible at once.
   - The problem list depends on country + stage (data from ask-sites.liquid,
     <script id="ask-data">). Country-specific problems come first.
   - Prefill from the URL: ?country=sweden&stage=money&p=M1&from=handle
   - Source tracking (?from= or the previous page on the same site).
   - Checks before sending, then success message after Shopify's redirect.
   ========================================================================== */
(function () {
  if (window.__askInit) return; window.__askInit = true;

  var DATA = { common: { stages: [], base: {} }, countries: [] };
  function loadData() {
    var el = document.getElementById('ask-data');
    if (!el) return;
    try { DATA = JSON.parse(el.textContent); } catch (e) {}
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  var params = new URLSearchParams(location.search);
  var FOREIGN = /foreign|permit|permission|allowed|nationality|passport|non-eu|land/i;


  /* Example in the question box: a city of the country picked (never a city from another country) */
  var CITY = {"albania": "Tirana", "austria": "Vienna", "belgium": "Brussels", "bulgaria": "Sofia", "croatia": "Split", "cyprus": "Limassol", "czech": "Prague", "denmark": "Copenhagen", "estonia": "Tallinn", "finland": "Helsinki", "france": "Nice", "germany": "Berlin", "greece": "Athens", "hungary": "Budapest", "ireland": "Dublin", "italy": "Rome", "latvia": "Riga", "lithuania": "Vilnius", "luxembourg": "Luxembourg City", "malta": "Sliema", "montenegro": "Budva", "netherlands": "Amsterdam", "norway": "Oslo", "poland": "Warsaw", "portugal": "Lisbon", "romania": "Bucharest", "serbia": "Belgrade", "slovakia": "Bratislava", "slovenia": "Ljubljana", "spain": "Valencia", "sweden": "Stockholm", "switzerland": "Geneva", "turkey": "Antalya", "uk": "Manchester", "argentina": "Buenos Aires", "brazil": "Florianópolis", "chile": "Santiago", "colombia": "Medellín", "costa-rica": "Tamarindo", "dominican": "Punta Cana", "guatemala": "Antigua", "honduras": "Roatán", "mexico": "Playa del Carmen", "nicaragua": "San Juan del Sur", "panama": "Panama City", "peru": "Lima", "uruguay": "Montevideo", "australia": "Brisbane", "cambodia": "Phnom Penh", "indonesia": "Bali", "japan": "Tokyo", "laos": "Vientiane", "malaysia": "Kuala Lumpur", "myanmar": "Yangon", "new-zealand": "Auckland", "philippines": "Cebu", "singapore": "Singapore", "south-korea": "Seoul", "thailand": "Phuket", "vietnam": "Da Nang", "cameroon": "Douala", "dr-congo": "Kinshasa", "ethiopia": "Addis Ababa", "gabon": "Libreville", "ghana": "Accra", "ivory-coast": "Abidjan", "mauritania": "Nouakchott", "mozambique": "Maputo", "nigeria": "Lagos", "republic-congo": "Brazzaville", "senegal": "Dakar", "south-africa": "Cape Town", "tanzania": "Zanzibar", "uganda": "Kampala", "kenya": "Nairobi", "rwanda": "Kigali", "algeria": "Algiers", "bahrain": "Manama", "egypt": "Hurghada", "iran": "Tehran", "israel": "Tel Aviv", "morocco": "Marrakech", "oman": "Muscat", "saudi-arabia": "Riyadh", "uae": "Dubai"};
  var EX = "e.g. We're buying a flat in {c}. The seller wants a 10% deposit before we sign the final deed, and the agent says it's normal. We haven't seen the land registry extract yet. Is it safe to pay now, or should we wait?";
  var EX0 = "e.g. We're buying a flat. The seller wants a 10% deposit before we sign the final deed, and the agent says it's normal. We haven't seen the land registry extract yet. Is it safe to pay now, or should we wait?";

  function countryBy(h) { for (var i = 0; i < DATA.countries.length; i++) if (DATA.countries[i].h === h) return DATA.countries[i]; return null; }
  function problemsFor(h, stage) {
    var c = countryBy(h), out = [];
    if (c && c.add && c.add[stage]) c.add[stage].forEach(function (p) { out.push(p); });
    (DATA.common.base[stage] || []).forEach(function (p) { out.push(p); });
    out.push(['Z', 'Something else']);
    return out;
  }
  function resolveP(h, p) {
    if (!p) return null;
    var c = countryBy(h), st, i, list;
    if (p === 'foreign') {
      var order = ['explore', 'money', 'found'];
      for (i = 0; i < order.length; i++) {
        list = (c && c.add && c.add[order[i]]) || [];
        for (var j = 0; j < list.length; j++) if (FOREIGN.test(list[j][1])) return [order[i], list[j][1]];
      }
      return ['money', 'Residence permit or visa'];
    }
    for (st in DATA.common.base) {
      list = DATA.common.base[st];
      for (i = 0; i < list.length; i++) if (list[i][0] === p) return [st, list[i][1]];
    }
    return null;
  }
  function sourceFromReferrer() {
    if (params.get('from')) return params.get('from');
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      if (r && r.host === location.host) {
        if (r.pathname === '/') return 'home';
        var parts = r.pathname.split('/').filter(Boolean);
        return parts[parts.length - 1] || r.pathname;
      }
      if (r) return 'external: ' + r.host;
    } catch (e) {}
    return 'direct';
  }

  function init(wrap) {
    var fid = wrap.getAttribute('data-fid');
    var form = wrap.querySelector('form');
    if (!form) return;
    var $ = function (s) { return wrap.querySelector(s); };
    var cSel = $('[data-ask-country]'), sSel = $('[data-ask-stage]'), pSel = $('[data-ask-problem]');
    var msg = $('[data-ask-msg]'), errEl = $('[data-ask-err]'), src = $('[data-ask-source]');
    var em = form.querySelector('input[type="email"]');
    var pFld = $('[data-ask-pfld]');
    var other = $('[data-ask-other]'), countEl = $('[data-ask-count]');
    function updCount() {
      if (!msg || !countEl) return;
      var n = msg.value.trim().length;
      countEl.textContent = n >= 30 ? '\u2713 Enough detail to get started' : (n === 0 ? '30 characters minimum' : (30 - n) + ' more characters');
      countEl.classList.toggle('is-ok', n >= 30);
    }
    function showOther() {
      if (!other) return;
      var on = cSel && cSel.value === 'Other';
      other.hidden = !on; if (!on) other.value = '';
    }
    function showP(on) {
      if (!pFld) return;
      pFld.hidden = !on;
      var n = 0;
      [].forEach.call(wrap.querySelectorAll('.ask-fld'), function (f) { if (!f.hidden) { var b = f.querySelector('.ask-num'); if (b) b.textContent = ++n; } });
    }

    if (src && !src.value) src.value = sourceFromReferrer();

    function opt(sel) { return sel && sel.selectedIndex > -1 ? sel.options[sel.selectedIndex] : null; }
    function cH() { var o = opt(cSel); return o ? (o.getAttribute('data-h') || '') : ''; }
    function cName() { var o = opt(cSel); return o && o.value && o.value !== 'Other' ? o.value : ''; }
    function stK() { var o = opt(sSel); return o ? (o.getAttribute('data-k') || '') : ''; }
    function paint(sel) { if (sel) sel.classList.toggle('is-empty', !sel.value); }
    function bad(el, on, t) {
      var f = el && el.closest('.ask-fld'); if (!f) return;
      f.classList.toggle('is-bad', !!on);
      var m = f.querySelector('.ask-ferr');
      if (on && t) { if (!m) { m = document.createElement('small'); m.className = 'ask-ferr'; f.appendChild(m); } m.textContent = t; }
      else if (!on && m) m.remove();
    }
    function showErr(t) { if (!errEl) return; errEl.textContent = t || ''; errEl.hidden = !t; }

    function setExample() {
      if (!msg) return;
      var c = CITY[cH()];
      msg.setAttribute('placeholder', c ? EX.replace('{c}', c) : EX0);
    }

    function buildProblems(pick) {
      if (!pSel) return;
      var keep = pick || pSel.value, st = stK(), h = cH();
      pSel.innerHTML = '';
      var first = document.createElement('option'); first.value = '';
      if (!cSel.value || !st) {
        first.textContent = !cSel.value && !st ? 'Pick your country and stage first' : (!cSel.value ? 'Pick your country first' : 'Pick your stage first');
        pSel.appendChild(first); pSel.disabled = true; paint(pSel); showP(false); return;
      }
      first.textContent = 'Pick the closest one';
      pSel.appendChild(first);
      var name = cName(), list = problemsFor(h, st), grp = null, local = [], rest = [];
      list.forEach(function (p) { (p[0].charAt(0) === 'X' ? local : rest).push(p); });
      function add(parent, p) {
        var o = document.createElement('option'); o.value = p[1]; o.textContent = p[1];
        if (keep && keep === p[1]) o.selected = true;
        parent.appendChild(o);
      }
      if (local.length && name) {
        grp = document.createElement('optgroup'); grp.label = 'Common in ' + name;
        local.forEach(function (p) { add(grp, p); }); pSel.appendChild(grp);
        var g2 = document.createElement('optgroup'); g2.label = 'Anywhere';
        rest.forEach(function (p) { add(g2, p); }); pSel.appendChild(g2);
      } else {
        local.concat(rest).forEach(function (p) { add(pSel, p); });
      }
      pSel.disabled = false; paint(pSel); showP(true);
    }

    wrap.addEventListener('change', function (e) {
      var t = e.target;
      if (t === cSel || t === sSel) buildProblems();
      if (t === cSel) { setExample(); showOther(); }
      paint(t.tagName === 'SELECT' ? t : null);
      if (t.value) bad(t, false);
      showErr('');
    });
    if (msg) msg.addEventListener('input', function () { updCount(); if (msg.value.trim().length >= 30) bad(msg, false); });
    if (other) other.addEventListener('input', function () { if (other.value.trim()) bad(other, false); });
    if (em) em.addEventListener('input', function () { bad(em, false); });

    form.addEventListener('submit', function (e) {
      var first = null, whys = [];
      function fail(el, t) { bad(el, true, t); whys.push(t); if (!first) first = el; }
      if (cSel && !cSel.value) fail(cSel, 'Pick a country (or "Somewhere else")');
      if (other && !other.hidden && !other.value.trim()) fail(other, 'Tell us which country');
      if (sSel && !sSel.value) fail(sSel, 'Tell us how far along you are');
      if (pSel && pFld && !pFld.hidden && !pSel.value) fail(pSel, 'Pick the problem closest to yours');
      if (msg && msg.value.trim().length < 30) fail(msg, 'Tell us a bit more about your situation (a couple of sentences)');
      if (em && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) fail(em, 'Check your email address');
      if (first) {
        e.preventDefault();
        showErr(whys.length === 1 ? 'Almost there: one thing is missing (in red above).' : 'Almost there: ' + whys.length + ' things are missing (in red above).');
        try { first.focus({ preventScroll: true }); } catch (x) {}
        first.closest('.ask-fld').scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      store('ask_sent', { fid: fid, stage: stK(), t: Date.now() });
      var btn = form.querySelector('.ask-send'); if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    });

    /* Prefill from the URL (country from the page wins if already set) */
    var pc = params.get('country');
    if (pc && cSel && !cSel.value) {
      for (var i = 0; i < cSel.options.length; i++) if (cSel.options[i].getAttribute('data-h') === pc) { cSel.selectedIndex = i; break; }
    }
    var rp = resolveP(cH(), params.get('p'));
    var ps = (rp && rp[0]) || params.get('stage');
    if (ps && sSel) { for (var k = 0; k < sSel.options.length; k++) if (sSel.options[k].getAttribute('data-k') === ps) { sSel.selectedIndex = k; break; } }
    buildProblems(rp ? rp[1] : null);
    paint(cSel); paint(sSel); setExample(); showOther(); updCount();

    /* After Shopify's redirect (?contact_posted=true) */
    var done = $('.ask-done'), body = $('.ask-body');
    if (done) {
      var sent = store('ask_sent');
      if (sent && sent.fid && sent.fid !== fid) { done.hidden = true; if (body) body.hidden = false; }
      else {
        document.documentElement.classList.add('ask-sent');
        setTimeout(function () { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); try { done.focus({ preventScroll: true }); } catch (e) {} }, 250);
        document.dispatchEvent(new CustomEvent('ask:sent', { detail: { stage: sent ? sent.stage : '', fid: fid } }));
      }
    }
  }

  /* Blog boxes: the title stays on one line on desktop (shrinks if needed) */
  function fitTitles() {
    [].forEach.call(document.querySelectorAll('.ask-box-t'), function (t) {
      t.style.removeProperty('font-size');
      if (window.innerWidth <= 640) return;
      var fs = parseFloat(getComputedStyle(t).fontSize), n = 0;
      while (t.scrollWidth > t.clientWidth + 1 && fs > 17 && n++ < 20) { fs -= 1; t.style.setProperty('font-size', fs + 'px', 'important'); }
    });
  }
  var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitTitles, 150); });
  window.addEventListener('load', fitTitles);

  /* Article phrases: scroll to the form at the end and pre-select stage + problem */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-ask-go]');
    if (!a) return;
    var wrap = document.querySelector('.ask-end [data-ask]') || document.querySelector('[data-ask]');
    if (!wrap) return;
    var bits = (a.getAttribute('data-ask-go') || '').split('|');
    var sSel = wrap.querySelector('[data-ask-stage]'), cSel = wrap.querySelector('[data-ask-country]');
    var h = cSel && cSel.selectedIndex > -1 ? cSel.options[cSel.selectedIndex].getAttribute('data-h') : '';
    var rp = resolveP(h, bits[1]); var st = (rp && rp[0]) || bits[0];
    if (st && sSel) {
      for (var k = 0; k < sSel.options.length; k++) if (sSel.options[k].getAttribute('data-k') === st) { sSel.selectedIndex = k; break; }
      sSel.dispatchEvent(new Event('change', { bubbles: true }));
      if (rp) { var pSel = wrap.querySelector('[data-ask-problem]'); if (pSel) { pSel.value = rp[1]; pSel.dispatchEvent(new Event('change', { bubbles: true })); } }
    }
  });

  /* Mobile bar on articles: shows after 30% of the article, hides near the form or once closed */
  function initBar() {
    var bar = document.querySelector('[data-ask-bar]'); if (!bar) return;
    if (store('ask_bar_off')) return;
    var art = document.querySelector('.ArticleContent'), end = document.querySelector('.ask-end');
    bar.hidden = false;
    function upd() {
      if (window.innerWidth > 640 || !art) { bar.classList.remove('is-on'); return; }
      var r = art.getBoundingClientRect(), past = -r.top / Math.max(1, r.height);
      var nearEnd = end && end.getBoundingClientRect().top < window.innerHeight * 1.2;
      bar.classList.toggle('is-on', past > 0.3 && !nearEnd);
    }
    window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    bar.querySelector('[data-ask-bar-close]').addEventListener('click', function () { bar.classList.remove('is-on'); store('ask_bar_off', 1); setTimeout(function () { bar.hidden = true; }, 300); });
    bar.querySelector('a').addEventListener('click', function () { bar.classList.remove('is-on'); });
  }

  function boot() { fitTitles(); initBar(); loadData(); [].forEach.call(document.querySelectorAll('[data-ask]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
